import { types } from 'mobx-state-tree';

export const StoreCompositionData = types.model('StoreCompositionData', {
  id: types.optional(types.number, 0),
  min: types.maybe(types.optional(types.number, 0)),
  max: types.maybe(types.optional(types.number, 0)),
  currentPercents: types.optional(types.number, 0),
  optimalPercents: types.optional(types.number, 0),
});
